import { render, staticRenderFns } from "./Prodcards.vue?vue&type=template&id=29528563"
var script = {}
import style0 from "./Prodcards.vue?vue&type=style&index=0&id=29528563&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports